
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/fixtures",
      function () {
        return require("private-next-pages/team/fixtures.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/fixtures"])
      });
    }
  